import React from 'react'
import { faBookBookmark,faShare,faLocation, faCompass, faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './FoodDetails.css';

const FoodDetails = () => {
    return (
        <>
            <div className="container">
                <div className="row">
                    <div class="container">
                        <div id="gallery" class="photos-grid-container gallery">
                            <div class="main-photo img-box-gallery">
                                <a href="https://images.unsplash.com/photo-1483985988355-763728e1935b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&h=1200&&q=80" class="glightbox" data-glightbox="type: image">
                                    <img src="https://images.unsplash.com/photo-1513104890138-7c749659a591?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80" alt="image" /></a>

                            </div>
                            <div>
                                <div class="sub">
                                    <div class="img-box-gallery">
                                        <img src="https://images.unsplash.com/photo-1594007654729-407eedc4be65?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1928&q=80" alt="" srcset="" />
                                    </div>
                                    <div class="img-box-gallery">
                                        <img src="https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1981&q=80" alt="image" />

                                    </div>
                                    <div class="img-box-gallery">
                                        <img src="https://images.unsplash.com/photo-1593560708920-61dd98c46a4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1935&q=80" alt="image" />

                                    </div>
                                    <div id="multi-link" class="img-box-gallery">
                                        <a href="https://images.unsplash.com/photo-1591557304122-513e396f9feb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NzZ8fHdvbWVuJTIwc2hvcHBpbmd8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=1200&h=1200&q=80" class="glightbox" data-glightbox="type: image">
                                            <img src="https://images.unsplash.com/photo-1593246049226-ded77bf90326?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1935&q=80" alt="image" />
                                            <div class="transparent-box">
                                                <div class="caption">
                                                    +3
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div id="more-img" class="extra-images-container hide-element">
                                <a href="https://images.unsplash.com/photo-1523450001312-faa4e2e37f0f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8ODF8fHdvbWVuJTIwc2hvcHBpbmd8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=1200&h=1200&q=80" class="glightbox" data-glightbox="type: image"><img src="https://images.unsplash.com/photo-1523450001312-faa4e2e37f0f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8ODF8fHdvbWVuJTIwc2hvcHBpbmd8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=900&h=900&q=60" alt="image" /></a>
                                <a href="https://images.unsplash.com/photo-1484081064812-86e90e107fa8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTQ4fHx3b21lbiUyMHNob3BwaW5nfGVufDB8fDB8fHww&auto=format&fit=crop&w=1200&h=1200&q=80" class="glightbox" data-glightbox="type: image"><img src="https://images.unsplash.com/photo-1484081064812-86e90e107fa8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTQ4fHx3b21lbiUyMHNob3BwaW5nfGVufDB8fDB8fHww&auto=format&fit=crop&w=900&h=900&q=60" alt="image" /></a>
                                <a href="https://images.unsplash.com/photo-1466695108335-44674aa2058b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&h=1200&q=80" class="glightbox" data-glightbox="type: image"><img src="https://images.unsplash.com/photo-1466695108335-44674aa2058b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=900&h=900&q=80" alt="image" /></a>

                            </div>
                        </div>
                    </div>


                    <div className="title-foodDetail mt-lg-4 mt-md-4 d-flex justify-content-between align-content-center ">
                        <div className="title d-flex justify-content-between align-content-center flex-column">
                            <h1>Pasta Carbonara</h1>
                            <div className="sub-title">
                                <p>North Indian</p>
                            </div>
                            <div className="location">
                                <h5> Navagar,Ahmedabad</h5>
                            </div>
                            <div className="btn-wrapper-fooddetail">
                                <button><FontAwesomeIcon className="icon-btn" icon={faLocation} />Direction</button>
                                <button><FontAwesomeIcon className="icon-btn" icon={faBookBookmark} />Bookmark</button>
                                <button><FontAwesomeIcon className="icon-btn" icon={faShare} />Share</button>
                            </div>
                        </div>
                        <div className="ratings">
                            <div className="rating-food">
                            </div>
                            <div className="reviews">
                                <p>
                                    1120 ⭐
                                </p>
                                <span>Delivert Reviews</span>
                            </div>
                        </div>
                    </div>
                    <div className="links-food">
                        <div className="all-food-detail-links mt-lg-4 mt-md-4 d-flex align-content-center justify-content-start">
                            <h3>Overview</h3>
                            <h3>Order Online</h3>
                            <h3>Reviwes</h3>
                            <h3>Photos</h3>
                        </div>
                    </div>
                    <div className="sidebar-scroll-menu-wrapper d-flex justify-content-start align-content-center mt-lg-4 mt-md-4 ">
                        <div className="sidebar">
                            <ul className='sidebar-list'>
                                <li>
                                    <p>Pauva (9)</p>
                                    <p>Sandwiches (2)</p>
                                    <p>Slices(1)</p>
                                    <p>Maggi</p>
                                    <p>Drinks (5)</p>
                                </li>
                            </ul>
                        </div>
                        <div className="content-food">
                            <h3>Order Online</h3>
                            <div className="small-para d-flex justify-content-between align-content-center">
                                <p><FontAwesomeIcon className="icon-compass" icon={faCompass} />Live Track Your Order</p>
                                <p><FontAwesomeIcon className="icon-compass" icon={faClock} />17 min</p>
                            </div>
                            <h1>Pauva</h1>
                            <div className="small-menu">
                                <div className="flex-wrapper-small-menu d-flex justify-content-start align-content-center">
                                    <div className="img-small-menu">
                                        <img src="https://images.unsplash.com/photo-1590947132387-155cc02f3212?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80" alt="" />
                                    </div>
                                    <div className="small-menu-content d-flex justify-content-center align-content-center flex-column">
                                        <h4 className='mb-0'>Pizza </h4>
                                        <div className="Votes">
                                            ⭐⭐⭐⭐
                                        </div>
                                        <div className="price-small-menu mt-lg-2 mt-md-2">
                                            ₹220
                                        </div>
                                        <div className="small-menu-para-con  mt-lg-2 mt-md-2">
                                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut blanditiis quaerat quam voluptatibus amet. Explicabo, voluptatum? Quas ex hic mollitia adipisci sunt pariatur assumenda tempora inventore, eos, consectetur atque qui.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-wrapper-small-menu d-flex justify-content-start align-content-center">
                                    <div className="img-small-menu">
                                        <img src="https://images.pexels.com/photos/2611917/pexels-photo-2611917.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="" />
                                    </div>
                                    <div className="small-menu-content d-flex justify-content-center align-content-center flex-column">
                                        <h4 className='mb-0'>Pasta </h4>
                                        <div className="Votes">
                                            ⭐⭐⭐⭐
                                        </div>
                                        <div className="price-small-menu mt-lg-2 mt-md-2">
                                            ₹220
                                        </div>
                                        <div className="small-menu-para-con  mt-lg-2 mt-md-2">
                                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut blanditiis quaerat quam voluptatibus amet. Explicabo, voluptatum? Quas ex hic mollitia adipisci sunt pariatur assumenda tempora inventore, eos, consectetur atque qui.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-wrapper-small-menu d-flex justify-content-start align-content-center">
                                    <div className="img-small-menu">
                                        <img src="https://images.unsplash.com/photo-1482049016688-2d3e1b311543?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=410&q=80" alt="" />
                                    </div>
                                    <div className="small-menu-content d-flex justify-content-center align-content-center flex-column">
                                        <h4 className='mb-0'>Noodles </h4>
                                        <div className="Votes">
                                            ⭐⭐⭐⭐
                                        </div>
                                        <div className="price-small-menu mt-lg-2 mt-md-2">
                                            ₹220
                                        </div>
                                        <div className="small-menu-para-con  mt-lg-2 mt-md-2">
                                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut blanditiis quaerat quam voluptatibus amet. Explicabo, voluptatum? Quas ex hic mollitia adipisci sunt pariatur assumenda tempora inventore, eos, consectetur atque qui.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-wrapper-small-menu d-flex justify-content-start align-content-center">
                                    <div className="img-small-menu">
                                        <img src="https://images.unsplash.com/photo-1590947132387-155cc02f3212?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80" alt="" />
                                    </div>
                                    <div className="small-menu-content d-flex justify-content-center align-content-center flex-column">
                                        <h4 className='mb-0'>Soft Drink </h4>
                                        <div className="Votes">
                                            ⭐⭐⭐⭐
                                        </div>
                                        <div className="price-small-menu mt-lg-2 mt-md-2">
                                            ₹220
                                        </div>
                                        <div className="small-menu-para-con  mt-lg-2 mt-md-2">
                                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut blanditiis quaerat quam voluptatibus amet. Explicabo, voluptatum? Quas ex hic mollitia adipisci sunt pariatur assumenda tempora inventore, eos, consectetur atque qui.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-wrapper-small-menu d-flex justify-content-start align-content-center">
                                    <div className="img-small-menu">
                                        <img src="https://images.unsplash.com/photo-1590947132387-155cc02f3212?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80" alt="" />
                                    </div>
                                    <div className="small-menu-content d-flex justify-content-center align-content-center flex-column">
                                        <h4 className='mb-0'>Pauva </h4>
                                        <div className="Votes">
                                            ⭐⭐⭐⭐
                                        </div>
                                        <div className="price-small-menu mt-lg-2 mt-md-2">
                                            ₹220
                                        </div>
                                        <div className="small-menu-para-con  mt-lg-2 mt-md-2">
                                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut blanditiis quaerat quam voluptatibus amet. Explicabo, voluptatum? Quas ex hic mollitia adipisci sunt pariatur assumenda tempora inventore, eos, consectetur atque qui.</p>
                                        </div>
                                    </div>
                                </div>





                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </>
    )
}

export default FoodDetails